type HasArrayChangesParams<T extends string> = {
  next: T[];
  previous: T[];
};

export const hasArrayChanges = <T extends string>(params: HasArrayChangesParams<T>): boolean => {
  const { next, previous } = params;

  if (next.length !== previous.length) return true;

  const sortedNext = [...next].sort();
  const sortedPrevious = [...previous].sort();

  return sortedNext.some((item, index) => item !== sortedPrevious[index]);
};
export const getSmallestItemByKey = <T>(array: T[], key: keyof T): T => {
  return array.reduce((smallest, current) => {
    return current[key] < smallest[key] ? current : smallest;
  }, array[0]);
};
